/**
 * Gets a query param from `location.search`. All params found are returned as
 * strings. Any params not found will return null.
 *
 * Examples:
 *   ```
 *   http://example.com?foo=2
 *   getQueryParam("foo") >>> "2"
 *   getQueryParam("bar") >>> null
 *   ```
 */
export const getQueryParam = (key: string): string | null => {
  const result = new URLSearchParams(location.search);
  return result.get(key);
};

